import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';

import { setFeedbackStatus } from '@/redux/feedback/feedbackSlice';
import { setDisplayModal } from '@/redux/app/appSlice';

import image from '@/images/modalFeedback/send-success.webp';

import Modal from '@/ui/modal';

import s from './modalSuccess.module.css';

function ModalSuccess({ close }) {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);

  const closeModal = () => {
    dispatch(setFeedbackStatus(null));
    dispatch(setDisplayModal(false));

    close();
  };

  return (
    <Modal close={closeModal}>
      <img src={image} alt="success" className={s.img} />
      <p className={s.title}>{i18n.ваш_запрос_принят}!</p>
      <p className={s.text}>{i18n.менеджер_свяжется_с_Вами}.</p>
      <button type="button" onClick={closeModal} className={s.btn_ok}>
        ok
      </button>
    </Modal>
  );
}

export default ModalSuccess;

ModalSuccess.propTypes = {
  close: PropTypes.func.isRequired,
};
